import { observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { IEbvSecAppActivationSigningResponse } from "types/ebvSecapp";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";

type IProps = RouteComponentProps<{}> & {
    store: SIdentitySettingsStore;
};

@observer
export class SIdentitySettingsAddDeviceSigning extends React.Component<IProps, {}> {
    render() {
        let signInfo;
        if (this.props.store.activationCodeResponse) {
            signInfo = this.props.store.activationCodeResponse.signInfo;
        }

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>
                                {ui.__("sidentitySettings.addDevice.summary")}
                            </pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    // Store QR code
                    this.props.store.addDeviceSigningResponse = response as IEbvSecAppActivationSigningResponse;
                    if (this.props.store.status?.secAppVariant === "APP" || this.props.store.status?.secAppVariant === "DUAL") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DEVICE_SUCCESS);
                    } else {
                        // Display QR code
                        pushRoute(SIdentitySettingsRoutes.CODE);
                    }
                }}

                onRetry={async () => {
                    await this.props.store.addDevice();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsAddDeviceSigning.tsx